/**
 * PUBLIC LOGIN
 *
 * @returns {Promise<void>}
 */
const main = async () => {
    const [
        {default: Vue},
        {ModalPlugin},
        {AjaxMixin},
        ErrorMessages,
        {ValidationProvider, ValidationObserver, extend, configure, localize},
        {required},
        VueScrollTo,
    ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "bs-modal" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "global-mixins-ajax" */ '@mymyMixins/ajax'),
        import(/* webpackChunkName: "global-translations-validation" */ '@mymyTranslations/validation'),
        import(/* webpackChunkName: "vee-validate" */ 'vee-validate'),
        import(/* webpackChunkName: "vee-validate-rules" */ 'vee-validate/dist/rules'),
        import(/* webpackChunkName: "vue-scrollto" */ 'vue-scrollto'),
    ]);

    Vue.use(ModalPlugin);

    Vue.use(VueScrollTo, {
        offset: -110,
    });

    // load our translated form error messages for this page's language
    localize(window.language, ErrorMessages.default[window.language]);

    // add our Vee Validate validators (email is already loaded)
    extend('required', required);

    // tell Vee Validate which classes to apply when a field is valid/invalid, etc
    configure({ classes: { invalid: 'is-invalid' } });

    const vm = new Vue({
        name: 'UserLoginForm',
        el: '#login',
        delimiters: ['[[', ']]'],
        mixins: [AjaxMixin],
        components: {
            'validation': ValidationProvider,
            'validation-observer': ValidationObserver,
        },
        data: {
            isLoading: false,
            loginName: '',
            password: '',
            rememberMe: '',
            redirectUrl: '',
            returnUrl: '',
            serverErrors: [],
        },
        mounted() {
            let form = JSON.parse(this.$el.dataset.form);
            this.loginName = form.loginName;
            this.redirectUrl = form.redirectUrl;
        },
        methods: {
            /**
             * Submit the form to Craft's controller and handle the response.
             *
             * @return {Promise<void>}
             */
            async onSubmit() {
                this.isLoading = true;
                this.serverErrors = [];

                const response = await this.makePostRequest('users/login', {
                    loginName: this.loginName,
                    password: this.password,
                    rememberMe: this.rememberMe,
                });

                if (response?.data?.user && response?.data?.returnUrl) {
                    window.location.href = response.data.returnUrl;
                }
                else if (response.response?.data?.errorCode) {
                    this.logErrors({message: [response.response.data.message]});
                }
                else {
                    this.logErrors({message: ["There was an error"]});
                    if(window.Sentry) {
                        Sentry.captureMessage("Response not handled correctly")
                    }
                }
            },


            // HELPERS
            // =====================================================================================

            /**
             * METHOD: Log any errors coming back from the server so they get shown to the user
             * on the front-end.
             *
             * @param errors
             * @param formNumber
             */
            logErrors(errors) {
                this.formSuccess = false;
                this.serverErrors = [];
                for (const erroredField in errors) {
                    for (const errorMessage of errors[erroredField]) {
                        this.serverErrors.push(errorMessage);
                    }
                }
                this.isLoading = false;
            },
        },
    });

    return vm;
};

// Execute async function
main().then( (vm) => {
});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}